/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect
} from "react";
import {
	connect
} from "react-redux";
import {
	useNavigate
} from "react-router-dom";

import {
	ComponentWrapper,
	HeaderLogoWrapper,
	HeaderWrapper
} from "./AuthView.styled";

import Logo from "../../Logo";

import routerHelper from "../../../helpers/router";
import storeHelper from "../../../helpers/store";

import useApi from "../../../hooks/api";

// INIT

/**
 * mapStateToProps - ...
 * 
 * @param {object} state ...
 */
const mapStateToProps = (state) => {
	return {
		...state
	};
};

// COMPONENT

const AuthView = (props) => {
	/*
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	*/
	const {
		fetchApi
	} = useApi();
	const navigate = useNavigate();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			const waitAsync = async () => {
				if(props.LOCAL.user.accessToken) {
					const response = await fetchApi({
						method: "get",
						params: {
							app_version: "4.0.0", // Note - Need to bypass native app checkup
							device_id: "1", // Note - Need to bypass native app checkup
							service: "me"
						}
					});

					if(!response.error) {
						storeHelper.dispatch(
							"SET_USER_NOTIFICATIONS", 
							{
								copped: response.payload.notifications.total_copped,
								listed: response.payload.notifications.total_listed,
								messages: response.payload.notifications.messages
							}
						);
						storeHelper.dispatch(
							"SET_USER_PROFILE", 
							{
								email: response.payload.email,
								firstName: response.payload.first_name,
								lastName: response.payload.last_name,
								phone: {
									countryCode: response.payload.phone_country_code,
									number: response.payload.phone
								}
							}
						);
						
						if(response.payload.saved_card) {
							storeHelper.dispatch(
								"SET_USER_SAVED_CARD", 
								{
									brand: response.payload.saved_card.type,
									last4: response.payload.saved_card.last4
								}
							);
						}
						/*
						storeHelper.dispatch(
							"SET_USER_SIZES", 
							{
								apparel: response.payload.sizes.apparel,
								footwear: response.payload.sizes.show
							}
						);
						*/

						navigate({
							pathname: routerHelper.getUrl("lists") // Note - Should redirect to Dashboard
						});

						return;
					}
				}
		
				storeHelper.dispatch(
					"RESET_ALL"
				);
			};

			waitAsync();
		}, 
		[]
	);

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		return (
			<ComponentWrapper>
				<HeaderWrapper>
					<div>
					</div>
					<div>
						<HeaderLogoWrapper>
							<Logo
								name="copdate"
							/>
						</HeaderLogoWrapper>
					</div>
					<div>
					</div>
				</HeaderWrapper>
				{props.children}
			</ComponentWrapper>
		);  
	};

	return render();
};

// EXPORT

export default connect(mapStateToProps)(AuthView);
